// FRILLORA-FUYU-PAIRING-QUICK-OPTIONS-v1
'FRILLORA-CART-OFFER-CONSISTENCY-20261104-v1';
(() => {
  'use strict';
  if (window.FrilloraNakedCart) return;
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const stringsNode = document.querySelector('[data-fr-nx-cart-strings]');
  let strings = {};
  try { strings = JSON.parse(stringsNode.textContent); } catch (_) {}
  const t = (key, values = {}) => Object.entries(values).reduce((value, [name, text]) => value.replaceAll('{' + name + '}', String(text)), strings[key] || key);
  const root = window.Shopify?.routes?.root || '/';
  const api = () => window.FrilloraCartEnhance;
  let last = null, quick = null;
  const format = (value, currency = last?.cart?.currency || window.Shopify?.currency?.active || drawer.dataset.cartCurrency || 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(value) / 100);
  const cards = [...drawer.querySelectorAll('[data-fr-nx-cart-rec]')];
  const recs = drawer.querySelector('[data-fr-nx-cart-recs]');
  const track = drawer.querySelector('[data-fr-nx-cart-recs-track]');
  const set = (selector, value) => { const node = drawer.querySelector(selector); if (node) node.textContent = value; };
  // FRILLORA-CART-BRAND-START-20261029
  const brandCache = new Map(), brandRequests = new Map(), brandPending = new Set();
  const brandGroups = new Set(['frillora-mky', 'frillora-ttlg', 'frillora-tg']);
  const normalizeBrand = value => { const group = String(value || '').trim().toLowerCase(); return brandGroups.has(group) ? group : ''; };
  function productBrand(product) {
    const tags = Array.isArray(product?.tags) ? product.tags : String(product?.tags || '').split(',');
    const groups = new Set(tags.map(normalizeBrand).filter(Boolean));
    return groups.size === 1 ? [...groups][0] : '';
  }
  function dominantCartBrand(items, getBrand) {
    const totals = new Map();
    for (const item of items) {
      const brand = getBrand(item), quantity = Number(item.quantity);
      if (!brand || item._frSelected === false || !Number.isFinite(quantity) || quantity <= 0) continue;
      const total = totals.get(brand) || { brand, quantity: 0, amount: 0 };
      const amount = Number(item.final_line_price ?? item.line_price ?? Number(item.final_price ?? item.price ?? 0) * quantity);
      total.quantity += quantity; total.amount += Number.isFinite(amount) ? amount : 0;
      totals.set(brand, total);
    }
    return [...totals.values()].sort((a, b) => b.quantity - a.quantity || b.amount - a.amount || (a.brand < b.brand ? -1 : a.brand > b.brand ? 1 : 0))[0]?.brand || '';
  }
  function eligibleCartGroupCandidates(pool, allItems, brand, allowDefault = false) {
    const desired = normalizeBrand(brand);
    if (!desired && !allowDefault) return [];
    const present = new Set(allItems.map(item => String(item.product_id)));
    const seen = new Set();
    return pool.filter(card => {
      const id = card.dataset.productId, image = card.querySelector('img');
      if (!id || seen.has(id) || present.has(id) || card.dataset.available === 'false' || !card.dataset.handle || !(image?.currentSrc || image?.src) || !Number.isFinite(Number(card.dataset.price))) return false;
      if (desired && normalizeBrand(card.dataset.brand) !== desired) return false;
      seen.add(id);
      return true;
    });
  }
  function chooseBrandFiller(pool, allItems, brand, remaining) {
    return eligibleCartGroupCandidates(pool, allItems, brand).slice().sort((a, b) => Math.abs(Number(a.dataset.price) - remaining) - Math.abs(Number(b.dataset.price) - remaining))[0] || null;
  }
  function strictCartGroupState(items) {
    const active = items.filter(item => item._frSelected !== false && Number.isFinite(Number(item.quantity)) && Number(item.quantity) > 0);
    const pending = ensureCartBrands(active);
    const unknown = active.some(item => !brandForItem(item));
    const brand = pending || unknown ? '' : dominantCartBrand(active, brandForItem);
    return {pending, unknown, brand};
  }
  function seedBrandMetadata() {
    for (const card of cards) if (card.dataset.brand !== undefined) brandCache.set(String(card.dataset.productId), normalizeBrand(card.dataset.brand));
    document.querySelectorAll('[data-fr-nx-cart-brands]').forEach(node => {
      try { for (const item of JSON.parse(node.textContent)) if (item?.id && typeof item.brand === 'string') brandCache.set(String(item.id), normalizeBrand(item.brand)); } catch (_) {}
    });
    document.querySelectorAll('[data-fr-cart-product-data],[data-fr-cart-products]').forEach(node => {
      try {
        const data = JSON.parse(node.textContent);
        for (const product of (Array.isArray(data) ? data : data.products || [data.product || data])) {
          if (product?.id && product.tags !== undefined) brandCache.set(String(product.id), productBrand(product));
        }
      } catch (_) {}
    });
  }
  function brandForItem(item) { return brandCache.get(String(item.product_id)) || ''; }
  function ensureCartBrands(items) {
    let pending = false;
    for (const item of items) {
      if (item._frSelected === false) continue;
      const id = String(item.product_id);
      if (brandCache.has(id)) continue;
      if (item.tags !== undefined) { brandCache.set(id, productBrand(item)); continue; }
      let handle = item.handle;
      try { if (!handle) handle = new URL(item.url, location.origin).pathname.split('/products/')[1]?.split('/')[0]; } catch (_) {}
      if (!/^[a-z0-9-]+$/i.test(handle || '')) { brandCache.set(id, ''); continue; }
      pending = true;
      if (brandPending.has(id)) continue;
      brandPending.add(id);
      if (!brandRequests.has(handle)) {
        const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 8000);
        const request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } })
          .then(response => response.ok ? response.json() : null).catch(() => null).finally(() => clearTimeout(timer));
        brandRequests.set(handle, request);
      }
      brandRequests.get(handle).then(product => {
        brandCache.set(id, String(product?.id) === id ? productBrand(product) : '');
      }).finally(() => { brandPending.delete(id); if (last) render(last); });
    }
    return pending;
  }
  seedBrandMetadata();
  // FRILLORA-CART-BRAND-END-20261029
  const describeCartOffer = function describeCartOffer(cart) {
  const pending = {kind:'empty', title:'Eligible offers', message:'Offers apply automatically to eligible items.', step:0, count:0, free:0, confirmed:false, ratio:0};
  if (!Array.isArray(cart?.items)) return {...pending, kind:'unknown'};
  let lingerie=0, other=0, unknown=false;
  const savings={lingerie:0,other:0,gift:0},free={lingerie:0,other:0,gift:0};
  for (const item of cart.items) {
    if (item._frSelected === false) continue;
    const quantity=Number(item.quantity);
    if (!Number.isSafeInteger(quantity)||quantity<1) {unknown=true;continue;}
    const handle=item.handle||String(item.url||'').match(/\/products\/([^/?]+)/)?.[1]||'';
    const tags=Array.isArray(item.tags)?item.tags:String(item.tags||'').split(',');
    const isFuyu=/^frillora-fy-\d+$/.test(handle)||tags.includes('FRILLORA-FY');
    if (isFuyu) lingerie+=quantity;
    else if (handle&&item.gift_card!==true) other+=quantity;
    else unknown=true;
    for (const allocation of item.line_level_discount_allocations||item.discount_allocations||[]) {
      const title=String(allocation.discount_application?.title||'').trim().toLowerCase().replace(/\.+$/,'');
      const kind=title==='lingerie: buy 2, get 1 free'?'lingerie':title==='suspender set + free stockings'?'gift':title==='buy 3, get 1 free'?'other':null;
      const amount=Number(allocation.amount),price=Number(item.original_price||item.price);
      if (kind&&Number.isFinite(amount)&&amount>0) {savings[kind]+=amount;if(price>0)free[kind]+=amount/price;}
    }
  }
  const applied=Object.keys(savings).filter(kind=>savings[kind]>0);
  if (applied.length>1) return {...pending,kind:'applied',title:'Applied offers',message:'Your eligible offers are applied in the order summary.',confirmed:true};
  if (applied[0]==='gift') return {...pending,kind:'gift',title:'Free Stocking Gift',message:'Your free stocking gift is applied.',free:Math.floor(free.gift+0.000001),confirmed:true,ratio:1};
  let kind=applied[0];
  if (!kind) {
    if (unknown) return {...pending,kind:'unknown'};
    if (lingerie&&other) return {...pending,kind:'mixed',title:'Eligible offers',message:'Lingerie: Buy 2, Get 1 Free. Other eligible styles: Buy 3, Get 1 Free.'};
    kind=lingerie?'lingerie':other?'other':null;
  }
  if (!kind) return pending;
  const step=kind==='lingerie'?3:4,count=kind==='lingerie'?lingerie:other;
  const title=kind==='lingerie'?'Lingerie: Buy 2, Get 1 Free':'Buy 3, Get 1 Free on eligible styles';
  const confirmed=savings[kind]>0,freeCount=Math.floor(free[kind]+0.000001),need=count?(step-count%step)%step:step;
  const message=confirmed?title+' applied.':need?title+'. Add '+need+' more '+(kind==='lingerie'?'lingerie':'eligible')+' item'+(need===1?'':'s')+'.':title+'. Your applicable discount is shown in the order summary.';
  return {kind,title,message,step,count,free:freeCount,confirmed,ratio:Math.min(1,count/(step*3))};
};
  function render(view) {
    if (!view?.cart || !view.state) return;
    last = view;
    const { cart, state } = view;
    const all = api()?.getItems?.() || cart.items || [];
    drawer.querySelectorAll('[data-fr-item]').forEach(line => {
      const item = all.find(entry => String(entry._frId) === line.dataset.frItem);
      const bottom = line.querySelector('.fr-cart-line-bottom');
      const price = line.querySelector('.fr-cart-line-price');
      const remove = line.querySelector('.fr-cart-remove-item');
      if (price && bottom && price.parentElement !== bottom) bottom.append(price);
      if (remove) { remove.classList.add('fr-nx-cart-line__remove'); remove.textContent = '×'; if (remove.parentElement !== line) line.append(remove); }
      if (item?._frSelected && price) {
        const original = Number(item.original_price || item.price) * Number(item.quantity);
        price.replaceChildren();
        if (Number(item.final_line_price) < original) price.append(element('s', '', format(original)));
        price.append(document.createTextNode(format(item.final_line_price)));
      }
    });
    const footer = drawer.querySelector('[data-cart-footer]');
    if (footer && !footer.querySelector('.fr-nx-cart-checkout-row')) {
      const total = footer.querySelector('.fr-sunfere-total');
      const actions = footer.querySelector('.fr-cart-payment-actions');
      if (total && actions) { const row = element('div', 'fr-nx-cart-checkout-row'); footer.insertBefore(row, total); row.append(total, actions); }
    }
    const nonempty = all.length > 0;
    drawer.dataset.frNxCartState = nonempty ? 'filled' : 'empty';
    const promotion=describeCartOffer(cart);
    set('[data-fr-nx-cart-reward-message]',promotion.message);
    set('[data-fr-nx-cart-offer-message]',promotion.message);
    set('[data-fr-nx-cart-offer] strong',promotion.title);
    const reward=drawer.querySelector('[data-fr-nx-cart-reward]');if(reward)reward.dataset.frOfferKind=promotion.kind;
    const fill=drawer.querySelector('[data-fr-nx-cart-reward-fill]');if(fill)fill.style.width=promotion.ratio*100+'%';
    for(const selector of ['.fr-nx-cart-reward__nodes','.fr-nx-cart-reward__track']){const node=drawer.querySelector(selector);if(node){node.hidden=!promotion.step;if(promotion.step)node.style.removeProperty('display');else node.style.setProperty('display','none','important');}}
    drawer.querySelectorAll('[data-fr-nx-cart-tier]').forEach(node=>{const tier=Number(node.dataset.frNxCartTier),label=node.querySelector('.fr-nx-cart-reward__label');if(promotion.step&&label?.firstChild)label.firstChild.textContent=label.firstChild.textContent.replace(/\d+/,String(tier*promotion.step));node.classList.toggle('is-unlocked',promotion.confirmed&&promotion.free>=tier);});
    const offer = drawer.querySelector('[data-fr-nx-cart-offer]'); if (offer) offer.hidden = !nonempty;
    const groupState = strictCartGroupState(cart.items || []);
    const brandsPending = groupState.pending;
    const dominantBrand = groupState.brand;
    const recommendationCards = recs ? cards.filter(card => recs.contains(card)) : [];
    const visibleRecommendations = new Set(eligibleCartGroupCandidates(recommendationCards, all, dominantBrand, !nonempty).slice(0, 6));
    let shown = 0;
    recommendationCards.forEach(card => { card.hidden = !visibleRecommendations.has(card); if (!card.hidden) shown += 1; });
    if (recs) { recs.hidden = !shown; recs.classList.toggle('fr-nx-cart-recs--grid', !nonempty); recs.classList.toggle('fr-nx-cart-recs--rail', nonempty); }
    set('[data-fr-nx-cart-recs-title]', t(nonempty ? 'choose_another' : 'best_sellers'));
    const filler = drawer.querySelector('[data-fr-nx-cart-filler]');
    // FRILLORA-CART-BRAND-RENDER-START-20261029
    const pick = nonempty && !brandsPending && !groupState.unknown && dominantBrand ? chooseBrandFiller(cards, all, dominantBrand, state.remaining) : null;
    if (filler) { filler.dataset.frNxCartBrand = dominantBrand; filler.dataset.frNxCartRecommendedBrand = pick ? normalizeBrand(pick.dataset.brand) : ''; }
    // FRILLORA-CART-BRAND-RENDER-END-20261029
    if (filler) {
      filler.hidden = !nonempty || state.remaining === null || state.remaining <= 0 || !pick;
      if (!filler.hidden) {
        const img = filler.querySelector('img'); img.src = pick.querySelector('img').currentSrc || pick.querySelector('img').src; img.alt = pick.querySelector('.fr-nx-cart-rec__title').textContent.trim();
        set('[data-fr-nx-cart-shipping]', t('shipping_away', { amount: format(state.remaining) }));
        set('[data-fr-nx-cart-filler-name]', img.alt);
        filler.querySelector('button').dataset.handle = pick.dataset.handle;
      }
    }
    drawer.querySelectorAll('[data-fr-cart-checkout]').forEach(button => button.dataset.frNxTotal = format(cart.total_price));
  }
  const element = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; };
  function closeQuick() {
    if (!quick || quick.saving) return;
    const state = quick; quick = null;
    state.options.querySelectorAll('.fr-variant-dropdown').forEach(control => control.frColorDropdown?.destroy());
    state.controller.abort(); state.dialog.close(); state.dialog.remove();
    document.body.classList.remove('fr-nx-cart-quick-open');
    state.opener?.focus({ preventScroll: true });
  }
  function matches(variant, choices, skip = -1) { return variant.options.every((value, i) => i === skip || choices[i] === null || value === choices[i]); }
  function dropdown(label, key, entries, selected, choose, fallbackImage) {
    const control = window.FrilloraColorDropdown.create({ label, entries, value: selected || '', placeholder: t('select_options'), fallbackImage, onChange: choose });
    control.dataset.nxOption = key; return control;
  }
  function drawOptions(state, focus) {
    if (quick !== state || !state.product) return;
    const { product, names, model, choices } = state;
    const variants = product.variants;
    const independent = model ? model.independent : names.map((_, i) => i);
    const available = variants.filter(variant => variant.available);
    const groups = [];
    for (const index of independent) {
      const values = [...new Set(variants.map(variant => variant.options[index]))];
      if (names[index] === 'Title' && values.length === 1 && values[0] === 'Default Title') continue;
      const group = element('fieldset', 'fr-nx-cart-quick__group'); group.append(element('legend', '', names[index]));
      if (/^colou?r$/i.test(names[index])) {
        group.append(dropdown(names[index], String(index), values.map(value => {
          const pool = variants.filter(variant => variant.options[index] === value && independent.every(i => i === index || choices[i] === null || variant.options[i] === choices[i]));
          const candidate = pool.find(variant => variant.available) || pool[0];
          return { value, label: value, image: candidate?.featured_image?.src || candidate?.featured_image || product.featured_image, disabled: !pool.some(variant => variant.available) };
        }), choices[index], value => { choices[index] = value; state.error.hidden = true; drawOptions(state, { index: String(index), value }); }, product.featured_image));
        groups.push(group); continue;
      }
      const options = element('div', 'fr-nx-cart-quick__values');
      for (const value of values) {
        const button = element('button', 'fr-nx-cart-quick__option', value); button.type = 'button'; button.dataset.nxOption = String(index); button.dataset.nxValue = value;
        button.disabled = !available.some(variant => variant.options[index] === value && independent.every(i => i === index || choices[i] === null || variant.options[i] === choices[i]));
        button.setAttribute('aria-pressed', String(choices[index] === value));
        button.addEventListener('click', () => { choices[index] = value; state.error.hidden = true; if (model && state.groupLabel && !model.groups.get(state.groupLabel)?.some(record => record.variant.available && independent.every(i => choices[i] === null || record.options[i] === choices[i]))) state.groupLabel = null; drawOptions(state, { index: String(index), value }); });
        options.append(button);
      }
      group.append(options); groups.push(group);
    }
    if (model) {
      const group = element('fieldset', 'fr-nx-cart-quick__group'); group.append(element('legend', '', t('color_pack')));
      const entries = [];
      model.groups.forEach((records, label) => {
        const pool = records.filter(record => independent.every(i => choices[i] === null || record.options[i] === choices[i]));
        if (!pool.length) return;
        const candidate = pool.find(record => record.variant.available)?.variant || pool[0].variant;
        entries.push({ value: label, label, image: candidate.featured_image?.src || candidate.featured_image || product.featured_image, disabled: !pool.some(record => record.variant.available) });
      });
      group.append(dropdown(t('color_pack'), 'pack', entries, state.groupLabel, value => { state.groupLabel = value; state.error.hidden = true; drawOptions(state, { index: 'pack', value }); }, product.featured_image)); groups.push(group);
    }
    state.options.querySelectorAll('.fr-variant-dropdown').forEach(control => control.frColorDropdown?.destroy());
    state.options.replaceChildren(...groups);
    const selected = independent.every(i => choices[i] !== null) ? model ? model.groups.get(state.groupLabel)?.find(record => record.variant.available && independent.every(i => record.options[i] === choices[i]))?.variant : available.find(variant => matches(variant, choices)) : null;
    state.variant = selected || null;
    state.submit.disabled = !selected || state.saving;
    state.submit.dataset.variantId = selected ? String(selected.id) : '';
    state.submit.textContent = selected ? t('add_price', { price: format(selected.price) }) : t('select_options');
    state.price.textContent = selected ? format(selected.price) : t('price_from', { price: format(Math.min(...available.map(variant => Number(variant.price)))) });
    const photo = selected?.featured_image?.src || selected?.featured_image || (state.pairingOptions ? state.previewVariant?.featured_image?.src || state.previewVariant?.featured_image : null) || product.featured_image;
    if (typeof photo === 'string') { const url = new URL(photo, location.origin); url.searchParams.set('width', '320'); state.image.src = url.href; }
    if (focus) {
      const control = [...state.options.querySelectorAll('[data-nx-option]')].find(node => node.dataset.nxOption === focus.index && (node.classList.contains('fr-variant-dropdown') || node.dataset.nxValue === focus.value));
      (control?.querySelector('[data-fr-dropdown-trigger]') || control)?.focus({ preventScroll: true });
    }
  }
  async function openQuick(handle, opener, pairingOptions = null) {
    if (!/^[a-z0-9-]+$/i.test(handle || '')) return;
    if (api()?.isPurchaseBlocked?.()) { const error = drawer.querySelector('[data-fr-nx-cart-rec-error]'); if (error) { error.textContent = t('bag_updating'); error.hidden = false; } return; }
    closeQuick(); if (quick) return;
    const dialog = element('dialog', 'fr-nx-cart-quick');
    const head = element('div', 'fr-nx-cart-quick__head');
    const heading = element('h2', '', t('choose_options')); heading.id = 'fr-nx-cart-quick-title'; dialog.setAttribute('aria-labelledby', heading.id);
    const close = element('button', 'fr-nx-cart-quick__close', '×'); close.type = 'button'; close.setAttribute('aria-label', t('close_options')); close.addEventListener('click', closeQuick); head.append(heading, close);
    const body = element('div', 'fr-nx-cart-quick__body');
    const productRow = element('div', 'fr-nx-cart-quick__product');
    const image = element('img', 'fr-nx-cart-quick__image'); image.width = 100; image.height = 130; image.alt = '';
    const info = element('div'); const title = element('h3', 'fr-nx-cart-quick__title', t('loading')); const price = element('p', 'fr-nx-cart-quick__price'); info.append(title, price); productRow.append(image, info);
    const options = element('div', 'fr-nx-cart-quick__options'); const error = element('p', 'fr-nx-cart-quick__error'); error.hidden = true; error.setAttribute('role', 'alert');
    const note = element('p', 'fr-nx-cart-quick__note', t('quantity_packs'));
    if (pairingOptions) note.hidden = true;
    const footer = element('div', 'fr-nx-cart-quick__footer'); const submit = element('button', 'fr-nx-cart-quick__submit', t('select_options')); submit.type = 'button'; submit.disabled = true; footer.append(submit);
    body.append(productRow, options, error, note); dialog.append(head, body, footer);
    const state = { dialog, opener, close, title, price, image, options, error, submit, controller: new AbortController(), saving: false, pairingOptions }; quick = state;
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeQuick(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeQuick(); } });
    submit.addEventListener('click', async () => {
      if (quick !== state || state.saving || !state.variant || !api()?.add) return;
      state.saving = true; submit.disabled = true; close.disabled = true; submit.textContent = t('adding'); error.hidden = true;
      try { await api().add({ id: Number(state.variant.id), quantity: 1 }); state.saving = false; close.disabled = false; closeQuick(); }
      catch (failure) { state.saving = false; close.disabled = false; error.textContent = failure?.message || t('retry'); error.hidden = false; drawOptions(state); }
    });
    document.body.append(dialog); document.body.classList.add('fr-nx-cart-quick-open'); dialog.showModal(); close.focus({ preventScroll: true });
    try {
      const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store', signal: state.controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw Error(t('retry'));
      const product = await response.json(); if (quick !== state) return;
      if (!Array.isArray(product.variants) || !product.variants.some(variant => variant.available)) throw Error(t('sold_out'));
      state.product = product; state.names = product.options.map(option => typeof option === 'string' ? option : option.name);
      state.choices = state.names.map((_, i) => { const values = [...new Set(product.variants.map(variant => variant.options[i]))]; return values.length === 1 ? values[0] : null; });
      const color = state.names.findIndex(name => /^(?:colou?r)$/i.test(name)); const pair = state.names.findIndex(name => /^(?:pairs?|packs?)$/i.test(name));
      state.model = color >= 0 && pair >= 0 ? window.FrilloraColorPackCore?.createModel(product.variants, { colorPosition: color + 1, pairPosition: pair + 1 }) : null;
      if (pairingOptions) {
        const initial = product.variants.find(variant => String(variant.id) === String(pairingOptions.initialVariantId) && variant.available);
        if (!initial) throw Error(t('retry'));
        state.previewVariant = initial;
        state.choices = state.names.map((name, index) => {
          const values = [...new Set(product.variants.map(variant => variant.options[index]))];
          if (values.length === 1) return values[0];
          return /^(?:colou?r|pairs?|packs?|style)$/i.test(name) ? initial.options[index] : null;
        });
        if (state.model) state.groupLabel = state.model.byId(initial.id)?.label || null;
      }
      if (state.model?.groups.size === 1) state.groupLabel = [...state.model.groups.keys()][0];
      state.title.textContent = product.title; state.image.alt = product.title;
      drawOptions(state);
    } catch (failure) { if (quick === state && failure?.name !== 'AbortError') { state.title.textContent = t('choose_options'); state.error.textContent = failure?.message || t('retry'); state.error.hidden = false; } }
  }
  document.addEventListener('click', event => {
    const button = event.target?.closest?.('button[data-fr-pairing-quick-open]');
    if (!button || !button.closest('[data-fr-fuyu-pairing]')) return;
    event.preventDefault();
    openQuick(button.dataset.handle, button, { initialVariantId: button.dataset.initialVariantId });
  });
  drawer.addEventListener('fr:naked-cart-state', event => render(event.detail));
  drawer.addEventListener('click', event => {
    const continueShopping = event.target.closest('.fr-drawer-empty a.fr-btn');
    const closeButton = continueShopping && drawer.querySelector('[data-cart-close]');
    if (continueShopping && closeButton) {
      event.preventDefault();
      closeButton.click();
      return;
    }
    const button = event.target.closest('[data-fr-nx-cart-rec-open],[data-fr-nx-cart-filler-open]');
    if (button) { event.preventDefault(); openQuick(button.dataset.handle || button.closest('[data-fr-nx-cart-rec]')?.dataset.handle, button); }
    const direction = event.target.closest('[data-fr-nx-cart-recs-prev],[data-fr-nx-cart-recs-next]');
    if (direction && track) track.scrollBy({ left: (direction.hasAttribute('data-fr-nx-cart-recs-prev') ? -1 : 1) * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  document.addEventListener('keydown', event => {
    if (!quick || event.key !== 'Escape') return;
    event.preventDefault(); event.stopImmediatePropagation();
    const expanded = quick.dialog.querySelector('[data-fr-dropdown-trigger][aria-expanded="true"]');
    if (expanded) { expanded.closest('.fr-variant-dropdown')?.frColorDropdown?.close(); expanded.focus({ preventScroll: true }); }
    else closeQuick();
  }, true);
  if (drawer.__frNakedCartView) render(drawer.__frNakedCartView);
  window.FrilloraNakedCart = Object.freeze({ render, closeQuick });
})();
